import { useState, useEffect } from 'react';
export default function useTheme() {
  // Xiaoying's warm-light homepage is the first-run default. Users can still
  // explicitly choose dark mode or follow the operating system.
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');
  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') root.classList.add('dark');
    else if (theme === 'light') root.classList.remove('dark');
    else {
      window.matchMedia?.('(prefers-color-scheme: dark)')?.matches
        ? root.classList.add('dark') : root.classList.remove('dark');
    }
    localStorage.setItem('theme', theme);
  }, [theme]);
  useEffect(() => {
    if (theme !== 'system') return;
    const mq = window.matchMedia?.('(prefers-color-scheme: dark)');
    if (!mq) return undefined;
    const h = e => e.matches ? document.documentElement.classList.add('dark') : document.documentElement.classList.remove('dark');
    mq.addEventListener?.('change', h);
    return () => mq.removeEventListener?.('change', h);
  }, [theme]);
  return { theme, setTheme };
}
